import { IRegionConfigWithFilters } from '../../types';

export const groupRegionConfigsByName = (regionConfigs: Array<IRegionConfigWithFilters>) => {
  const allRegionConfigOptions: { label: string; value: string }[] = [];
  regionConfigs.forEach((regionConfig: IRegionConfigWithFilters) => {
    const withAgent =
      regionConfig?.regionConfig?.withAgent && Object.keys(regionConfig?.regionConfig?.withAgent).length;

    if (withAgent) {
      const withAgentRegionLabel = `${regionConfig?.regionConfig?.withAgent?.configName} (With Agent)`.replace('+', '');
      const withAgentRegionValue = `${regionConfig?.id ?? ''}_rconfig_with_agent`;

      const foundWithAgentOption = allRegionConfigOptions.find(option => option.label === withAgentRegionLabel);
      if (foundWithAgentOption) {
        foundWithAgentOption.value = `${regionConfig?.id ?? ''}|${foundWithAgentOption.value}`;
      } else {
        allRegionConfigOptions.push({ label: withAgentRegionLabel, value: withAgentRegionValue });
      }
    }

    const directRegionLabel = regionConfig?.regionConfig?.default?.configName;
    const directRegionValue = `${regionConfig?.id ?? ''}_rconfig_${withAgent ? 'without_agent' : ''}`;

    const foundDirectOption = allRegionConfigOptions.find(option =>
      [`${directRegionLabel} (Direct)`, directRegionLabel].includes(option.label),
    );
    if (foundDirectOption) {
      foundDirectOption.value = `${regionConfig?.id ?? ''}|${foundDirectOption.value}`;
    } else {
      allRegionConfigOptions.push({
        label: withAgent ? `${directRegionLabel} (Direct)` : directRegionLabel,
        value: directRegionValue,
      });
    }
  });
  return allRegionConfigOptions;
};
